var sccaid;
var scorno;
var myFundPageno;
var combinedSubAccountTransCodes = ['06001', '06010', '06020', '06030', '06143', '06144']; // 组合子账户交易类型
var targetProfitTransCodes = ['06040', '06050']; // 目标盈交易记录
var aPlusPayTransCodes = ['02604']; // A加付交易记录

function apiQryTransInfo(pageno) {
    myFundPageno = pageno;
    if (!isRealName()) {
        $('#onRoadTable').html('<td colspan="5"><div class="hold-box h-min"><p class="no-data">暂无在途交易记录</p></div></td>');
        return;
    }



    toApi('getbindbankcardlist.tml', function (data2) {
        var mainCardNo = null;
        var mainBrchna = null;
        var mainFlag = 0;
        if (data2.bindCardInfos.length > 0) {
            for (var i = 0; i < data2.bindCardInfos.length; i++) {
                if (data2.bindCardInfos[i].mainFlag == 1) {
                    mainFlag = 1;
                    mainCardNo = data2.bindCardInfos[i].cardno;
                    mainBrchna = data2.bindCardInfos[i].brchna;
                    break;
                }
            }
            if (mainFlag == 0) {
                mainCardNo = data2.bindCardInfos[0].cardno;
                mainBrchna = data2.bindCardInfos[0].brchna;
            }
        }

        var params = {
            trantp: 0,
            pageno: pageno,
            pagesz: 1000,
            traflg: 1,
            qryTranKind: 2
        };

        toApi_toAc('S091540', params, function (data) {

            if (data.state === '0') {

                if (data.wlinfo.length > 0) {
                    $('#transitTransaction').removeClass('none');

                    data.wlinfo.forEach(function (e) {
                        e.tranam = toThousands(e.tranam, 2);
                        if (e.tofundname === '') {
                            e.tofundname = 'A加钱包';
                        }
                        if (e.fundName === '') {
                            e.fundName = '钱包';
                        }

                        if (e.prcscd === '02410' || e.prcscd === '03601' || e.prcscd === '03604' || e.prcscd === '03606') {
                            e.tranam = toThousands(e.occur_share, 2) + "份";
                        } else if (e.prcscd === '14301' || e.prcscd === '14311' || e.prcscd === '14211') {
                            e.tranam = toThousands(e.confirm_amount, 2) + "元";
                        } else if (e.prcscd === '14302' || e.prcscd === '14201' || e.prcscd === '14401' || e.prcscd === '14501' || e.prcscd === '14411' || e.prcscd === '14511' || e.prcscd === '14312') {
                            e.tranam = toThousands(e.confirm_share, 2) + "份";
                        } else if (e.prcscd === '03614' || e.prcscd === '14312' || e.prcscd === '14411' || e.prcscd === '14511') {
                            e.tranam = "";
                        } else {
                            e.tranam += "元";
                        }

                        if (e.prcscd === '02204') {
                            e.cardno = mainCardNo;
                            e.brchna = mainBrchna;
                        }

                        if (e.prcscd === '02210' || e.prcscd === '02211' || e.prcscd === '02410' || e.prcscd === '03601' || e.prcscd === '02001' || e.prcscd === '03902') {
                            if (e.transt_tmp === '3') {
                                e.transt = '申请已受理';
                            }
                        }

                        if (e.prcscd === '02202' && e.orderType === '0') {
                            if (e.transt_tmp === '3') {
                                e.transt = '申请已受理';
                            }
                        }

                        if (e.prcscd === '02202' && isNull(e.fundName) && isNull(e.prodna)) {
                            e.fundName = '钱包';
                        }

                        e.trandt1 = e.trandt + ' ' + (e.trantm || '');

                        // 组合子账户与目标盈不展示fundCode
                        if (!combinedSubAccountTransCodes.includes(e.prcscd) && !targetProfitTransCodes.includes(e.prcscd)) {
                            e.isFundCodeShow = true;
                        }
                    });
                    console.log('>>>>>>>>>>>>>>>>>>>', data.wlinfo);
                    var htmlList = template('onRoad', {
                        "list": data.wlinfo
                    });
                    $('#onRoadTable').html(htmlList);
                } else {
                    $('#onRoadTable').html('<td colspan="5"><div class="hold-box h-min"><p class="no-data">暂无在途交易记录</p></div></td>');
                }
            } else {
                alert(data.respMsg);
            }
        }, 'myfund', '');
    }, 'myfund', '');
}


//分页
function toPage_0(index, pages, type) {
    if (type == 1) {
        if (index + 1 <= pages) {
            getOnloadNum(index + 1);
        }
    } else if (type == -1) {
        if (index - 1 >= 1) {
            getOnloadNum(index - 1);
        }
    } else {
        var num = 1;
        try {
            num = parseInt($('#toPage_0').html());
        } catch (err) {
            num = 1;
        }
        if (num > 0 && num <= pages) {
            getOnloadNum(num);
        }
    }
}


$(function () {
    islogin();
    //热门推荐
    setHotRecommend();
    $('#unbindcard').remove();
    $("#bindcard").removeClass("none");
    var cardLen = localStorage.cardLen;
    if (!isRealName() || isNull(cardLen) || Number(cardLen) <= 0) {
        // $("#positionFund").hide();
        // return;
    }

    getOnloadMoney();

    //在途交易列表
    if (!isNull(localStorage.myFundPageno)) {
        getOnloadNum(localStorage.myFundPageno);
        localStorage.myFundPageno = "";
    } else {
        getOnloadNum(1);
    }

    getAssets();

    toApi_toAcCg('S15Q032', { fundCode: '206390' }, function (data) { });
    // var personalFundCode = getPersonalFundCode();
    // if (!isNull(personalFundCode)) {
    //     setHoldList(personalFundCode);
    // } else {
    //     toApi("qrywalletfundcode.tml", function (data) {
    //         localStorage.personalFundCode = data.personalFundCode;
    //         setHoldList(data.personalFundCode);
    //     });
    // }
});

function setHoldList(personalFundCode) {
    //产品列表
    // toApi("fundpositionslist.tml?playFlg=0", function(data) {

    // }, 'myfund', '');
    var params = {
        playFlg: 1,
        // financedType: '07'
    };
    toApi_toAc("S091544", params, function (data) {

        var list1 = [];
        var list2 = [];
        var list3 = [];
        var list7 = [];
        data.funds.forEach(function (e) {
            if (e.isWalletAsset != '1') {
                var valeAndColor = numberFormatter(e.positionIncome, 2);
                var valeAndColor2 = numberFormatter(e.yestodayPro, 2);
                var valueAndColor3 = numberFormatterWithSign(e.totalIncomeYield, 2);
                e.totlam = valeAndColor.value;
                e.totlamcolor = valeAndColor.color;
                e.yestodayPro = valeAndColor2.value;
                e.yestodayProcolor = valeAndColor2.color;
                e.assertMarketValue = toThousands(e.assertMarketValue, 2);
                e.totalIncomeYield = valueAndColor3.value;
                e.totalIncomeYieldColor = valueAndColor3.color;
                e.isShowFundExit = e.isSpecialOutFund == '1' && e.state == e.specialFundState;

                if (e.fundSubType === '1') {
                    var openDateStart = e.openDateStart;
                    var openDateEnd = e.openDateEnd;
                    if (!isNull(openDateStart) && !isNull(openDateEnd)) {
                        e.openDate = Number(openDateStart.substring(4, 6)) + '月' + Number(openDateStart.substring(6, 8)) + '日' + '~' + Number(openDateEnd.substring(4, 6)) + '月' + Number(openDateEnd.substring(6, 8)) + '日';
                    } else {
                        e.openDate = '暂无';
                    }
                    e.isOpen = isInReservationPeriod(e.applyDateStart, e.applyDateEnd, e.nowTime);
                    if (e.state === 'b' || e.state === 'c' || e.state === 'd') {
                        if (e.isOpen) {
                            e.buyFlag = '0';
                        } else {
                            e.buyFlag = '1';
                        }
                    } else if (e.state === '0' || e.state === '1' || e.state === '6' || e.state === '7' || e.state === '8') {
                        e.buyFlag = '2';
                    } else {
                        e.buyFlag = '3';
                    }
                    list1.push(e);
                } else if (e.fundSubType === '3') {

                } else {
                    list2.push(e);
                }
            }
        });
        var params1 = {
            playFlg: 0,
            financedType: "02"
        };
        // 通过[基金持仓分页列表]接口获取用户持仓明细
        toApi_toAc("S091544", params1, function (data1) { // 货币plus
            data1.funds.forEach(function (e) {
                var rateAndColor = numberFormatter(e.positionIncome, 2);
                var rateAndColor2 = numberFormatter(e.yestodayPro, 2);
                e.assertMarketValue = toThousands(e.assertMarketValue);
                e.totlam = rateAndColor.value;
                e.totlamcolor = rateAndColor.color;
                e.yestodayPro = rateAndColor2.value;
                e.yestodayProcolor = rateAndColor2.color;
                var yieldAndColor = numberFormatter(e.totalIncomeYield, 2);
                e.totalIncomeYield = yieldAndColor.value + '%';
                e.totalIncomeYieldColor = yieldAndColor.color;
                list3.push(e);
            });

            if (list3.length > 0) {
                var htmlList = template('hbProduct', {
                    "list": list3
                });
                $('#hbproductTable').html(htmlList);
            } else {
                $('#hbproductTable').html('<td colspan="5"><div class="hold-box h-min"><p class="no-data">暂无数据</p></div></td>');
            }
        });
        // toApi('fundpositionslist.tml?playFlg=0&financedType=02', function(data1) {

        // });

        /**
         * 稳收宝
         */

        // toApi('fundassetinformation.tml?playFlg=0&financedType=08', function(data1) {

        // });
        var params2 = {
            playFlg: 0,
            financeType: "08"
        };
        toApi_toAc("S15Q084", params2, function (data1) { // 稳收宝
            var e = {};
            var walamt_wenShou = data1.avalableShare;
            var yesrevTitle_wenShou = data1.dayIncomeTitle;

            var totalr_wenShou = numberFormatter(data1.sumPortfolioPositionIncome, 2);
            var yesrev_wenShou = numberFormatter(data1.dayIncome, 2);

            e.assertMarketValue = toThousands(walamt_wenShou);
            e.totlam = totalr_wenShou.value;
            e.totlamcolor = totalr_wenShou.color;
            e.yestodayPro = yesrev_wenShou.value;
            e.yestodayProcolor = yesrev_wenShou.color;
            e.prodna = "钱包稳收宝";
            e.fundCode = data1.fundCode;
            e.yesrevTitle_wenShou = yesrevTitle_wenShou;
            list7.push(e);

            if (Number(walamt_wenShou) > 0) {
                $('#wenShouList').removeClass('none');
                var htmlList = template('wenShouProduct', {
                    "list": list7
                });
                $('#wenShouproductTable').html(htmlList);
            }
        });

        if (list1.length > 0) {
            var htmlList = template('pro', {
                "list": list1
            });
            $('#proTable').html(htmlList);
        } else {
            $('#gdDiv').addClass("none");
            $('#gdTable').addClass("none");
        }

        // if (list2.length > 0) {
        //     var htmlList = template('product', {
        //         "list": list2
        //     });
        //     $('#productTable').html(htmlList);
        // } else {
        //     $('#productTable').html('<td colspan="5"><div class="hold-box h-min"><p class="no-data">暂无数据</p></div></td>');
        // }
    }, function (err) {
        if (err.respCode == '100000') {
            window.location.href = phURL + "login.html";
        }
    });

    // 货币PLUS
    // toApi_toAc('S091503', {}, function (data) {
    //     if (data.state === '0') {
    //         var list = [];
    //         data.portfolioAcctWithHoldingList.forEach(function (e) {
    //             var rateAndColor = numberFormatter(e.positionIncome, 2);
    //             var rateAndColor2 = numberFormatter(e.yesterdayIncome, 2);

    //             e.assertMarketValue = toThousands(e.assetMarketValueWithoutOnWay);
    //             e.totlam = rateAndColor.value;
    //             e.totlamcolor = rateAndColor.color;
    //             e.yestodayPro = rateAndColor2.value;
    //             e.yestodayProcolor = rateAndColor2.color;
    //             list.push(e);
    //         });

    //         if (list.length > 0) {
    //             var htmlList = template('combinedTemplate', {
    //                 "list": list
    //             });
    //             $('#combinedList').html(htmlList);
    //         } else {
    //             $('#combinedList').html('<td colspan="5"><div class="hold-box h-min"><p class="no-data">暂无数据</p></div></td>');
    //         }
    //     } else {
    //         alert(data.respMsg);
    //     }
    // });

    // 目标盈持仓
    toApi_toAc('S091610', {
        portfolioType: 'TP'
    }, function (data) {
        if (data.state === '0') {
            var list = [];
            data.portfolioAcctWithHoldingList.forEach(function (e) {
                var rateAndColor = numberFormatter(e.positionIncome, 2);
                var rateAndColor2 = numberFormatter(e.yesterdayIncome, 2);

                e.assertMarketValue = toThousands(e.assetMarketValueWithoutOnWay);
                e.totlam = rateAndColor.value;
                e.totlamcolor = rateAndColor.color;
                e.yestodayPro = rateAndColor2.value;
                e.yestodayProcolor = rateAndColor2.color;
                list.push(e);
            });

            if (list.length > 0) {
                var htmlList = template('combinedTemplate', {
                    "list": list
                });
                $('#TPList').html(htmlList);
            } else {
                $('#TPList').html('<td colspan="5"><div class="hold-box h-min"><p class="no-data">暂无数据</p></div></td>');
            }
        } else {
            alert(data.respMsg);
        }
    });
}

function recharge() {
    window.location.href = phURL + "wallet/recharge.html";
}

function wdoffer(caid, odno) {
    if (caid == 0 && odno == 0) {
        sccaid = caid;
        scorno = odno;
        $('#wdoffervi').removeClass('none');
        $('#wdoffervi').addClass('pup-model');
    }
}

function before() {
    $('#wdoffervi').removeClass('pup-model');
    $('#wdoffervi').addClass('none');
    location.reload();
}

function next() {
    $('#wdoffervi').removeClass('pup-model');
    $('#wdoffervi').addClass('none');
    $('#wdoffervi2').removeClass('none');
    $('#wdoffervi2').addClass('pup-model');
}

function back() {
    $('#wdoffervi2').removeClass('pup-model');
    $('#wdoffervi2').addClass('none');
    location.reload();
}

function wdoffernext() {

    if (isNull('#paySc').val()) {
        errShow('paySc', '交易密码还未输入，请先输入交易密码');
        return;
    }
    if (!checkTransPwd2("paySc", '交易密码不合法')) {
        return;
    }
    var paySc = $('#paySc').val();
    //通过[密钥下发]接口获取密码RSA秘钥
    toApi('getPubKey.tml?type=' + 2, function (data) {

        var publicKey = data.key;
        var r_p = RSAUtil_transPwd(paySc, publicKey);

        //通过[验证交易密码]接口验证用户输入的交易密码147258
        toApi('verTransPwd.tml?transPwd=' + r_p, function (data) {

            //通过[交易撤单]接口对交易进行撤单
            toApi('transcancellation.tml?transAcctid=' + sccaid + '&order_no=' + scorno + '&transPwd=' + r_p, function (data) {
                $('#wdoffervi2').removeClass('pup-model');
                $('#wdoffervi2').addClass('none');
                location.reload();
            });

        }, function (data) {
            if (data.respCode == '0841000013') {
                alert("交易密码错误！");
            } else if (data.respCode == '0820010049') {
                showErrorMsg(data.respMsg, data.respType);
            } else {
                showErrorMsg(data.respMsg, data.respType);
            }
        });

    });

}

function detail(prcscd, orderNo, dividendFund, capitalMode, transt, remark) {

    if (prcscd == '02202' && capitalMode == 'K' && remark == 'HK' && transt == '3') {
        alertIknowMsg('您已汇款。<br/>如有疑问，请详询鹏华客服热线400-6788-533');
        return;
    }

    // 目标盈交易
    if (targetProfitTransCodes.indexOf(prcscd) > -1) {
        alertIknowMsg('目标盈持仓暂时无法查看详情');
        return;
    }

    if (aPlusPayTransCodes.includes(prcscd)) {
        alertIknowMsg('A加付消费记录暂时无法查看详情');
        return;
    }

    if (dividendFund == '3' || dividendFund == '4') {
        alertIknowMsg('组合持仓暂时无法查看详情');
        return;
    }

    if (prcscd == "0" && orderNo == "0") {
        return
    }

    localStorage.myFundPageno = myFundPageno;
    // sessionStorage.setItem("pageIdToTransActionDetails", "2");
    window.location.href = phURL + "account/detail.html?orderNo=" + orderNo + "&transCode=" + prcscd + "&URL=fund/myFund.html";
}

function bindCardNow() {
    if (isRealName()) {
        gotoAddmybindbankcard();
    } else {
        gotoFirstbindcard();
    }
}

function goFundInvestment(serType, fundCode, prodna, isPortfolioAsset) {
    toApi_toAcCg("S15Q032",{fundCode:fundCode},function(res){
        productTypeCode = res.productTypeCode || '0';
        if(productTypeCode == '1'){
            alertIknowMsg('滚动持有期产品暂不支持定投业务')
        }else{
            if (isPortfolioAsset == '1') {
                alertIknowMsg('组合持仓暂时无法查看详情');
                return;
            }
            return (serType === '0') ? alert('该基金暂不可定投') : fundInvestment(fundCode, prodna);
        }


    })

}

function gotoNextPage(pageId, fundCode, shareType, fundType, isPortfolioAsset, productCode, agencyNo, isAplusAsset, channelCode, transAcctIdSub) {

    if (isPortfolioAsset == '1') {
        alertIknowMsg('组合持仓暂时无法查看详情');
        return;
    } else if (productCode == "目标盈" || productCode == "止盈" || productCode == "智能定投") {
        combinedTip('本产品需通过A加钱包APP进行查看');
    } else {
        if (transAcctIdSub) {
            localStorage.whereComeFromMyFund = 'fund/myFund.html';
            window.location.href = window.phURL + pageId + '?fundCode=' + fundCode + '&shareType=' + shareType + '&fundType=' + fundType + '&agencyNo=' + agencyNo + '&isAplusAsset=' + isAplusAsset + '&channelCode=' + channelCode + '&transAcctIdSub=' + transAcctIdSub;
        } else {
            localStorage.whereComeFromMyFund = 'fund/myFund.html';
            window.location.href = window.phURL + pageId + '?fundCode=' + fundCode + '&shareType=' + shareType + '&fundType=' + fundType;
        }
    }
}

function goDetail(pageId, fundCode, fundType, isPortfolioAsset, productCode) {
    //组合详情
    if (isPortfolioAsset == '1') {
        alertIknowMsg('组合持仓暂时无法查看详情');
        return;
    } else if (productCode == "目标盈" || productCode == "止盈" || productCode == "智能定投") {
        combinedTip('本产品需通过A加钱包APP进行查看');
    } else {
        window.location.href = window.phURL + pageId + '?fundCode=' + fundCode + '&fundType=' + fundType;
    }
}

function goDetail2(pageId, fundCode, fundType, dividendFund, transCode) {
    if (isNull(fundCode)) {
        return;
    }

    if (targetProfitTransCodes.indexOf(transCode) > -1) {
        alertIknowMsg('目标盈持仓暂时无法查看详情');
        return;
    }

    //组合详情
    if (dividendFund == '3' || dividendFund == '4') {
        alertIknowMsg('组合持仓暂时无法查看详情');
        return;
    } else {
        window.location.href = window.phURL + pageId + '?fundCode=' + fundCode + '&fundType=' + fundType;
    }
}


function gotoFundBuy() {
    // {
    //     fundCode: outLineFundCode,
    //     productInfoId: loadValue("summaryID", false),
    //     transCode: outLineUrl == "addfundinvestment" ? "039" : "020", // 认申购020，定投039，转换036
    //     ptfCode: 0
    // }
    if (!loadValue("unScrollbottom", false)) {
        alert("请先完成全文阅读");
        return;
    }
    removeValue("unScrollbottom", false);
    $("#pupFundOutline").hide();
    var outLineFundCode = loadValue("outLineFundCode", false);
    var outLineUrl = loadValue("outLineUrl", false);
    var outLineFundName = loadValue("outLineFundName", false);
    removeValue("outLineFundCode", false);
    removeValue("outLineUrl", false);
    var S092019params = {
        fundSummaryVos: fundSummaryArr,
        source: 'position'
    };
    var nextPage = function () {
        removeValue("summaryID", false);
        if (outLineUrl == "addfundinvestment") {
            window.location.href = phURL + 'fund/addfundinvestment.html?fundName=' + outLineFundName + '&fundCode=' + outLineFundCode;
        } else {
            window.location.href = window.phURL + 'fund/fundBuy.html?fundCode=' + outLineFundCode;
        }
    };
    toApi_toAc("S092019", S092019params, nextPage, '', '', nextPage);
}

function readNext(){
    console.log(222222,itemArr)
    //循环对象，找到下一个未读的展示，如果找不到，则代表全部已读，执行之后的业务逻辑
    noReadArr= itemArr.filter(function(val){
        return val.hasRead == false
    })
    console.log(33333,noReadArr)
    if(noReadArr.length==0){
        $("#pupFundOutline").hide();
        var outLineFundCode = loadValue("outLineFundCode", false);
        var outLineUrl = loadValue("outLineUrl", false);
        var outLineFundName = loadValue("outLineFundName", false);
        removeValue("outLineFundCode", false);
        removeValue("outLineUrl", false);
        var S092019params = {
            fundSummaryVos: fundSummaryArr,
            source: 'position'
        };
        var nextPage = function () {
            removeValue("summaryID", false);
            if (outLineUrl == "addfundinvestment") {
                window.location.href = phURL + 'fund/addfundinvestment.html?fundName=' + outLineFundName + '&fundCode=' + outLineFundCode;
            } else {
                window.location.href = window.phURL + 'fund/fundBuy.html?fundCode=' + outLineFundCode;
            }
        };
        toApi_toAc("S092019", S092019params, nextPage, '', '', nextPage);

    }else{
        // nowIndex = noReadArr[0].eq;
        console.log(nowIndex);
    
        if (itemArr[nowIndex].hasRead) {
          if (parseInt(nowIndex) + 1 == itemArr.length) {
            nowIndex = 0;
          } else {
            nowIndex++;
          }
          $(".outLine_box").eq(nowIndex).show().siblings().hide();
          $(".titleItem")
            .eq(nowIndex)
            .addClass("active")
            .siblings()
            .removeClass("active");
          return;
        }
        itemArr[nowIndex].hasRead = true;
    
        hasReadNum = itemArr.filter(function (val) {
          return val.hasRead == true;
        }).length;
        if (parseInt(hasReadNum) < itemArr.length) {
          $(".nextBtn2").text(
            "我已阅读并知悉(" + hasReadNum + "/" + itemArr.length + ")"
          );
        } else {
            readNext();
        }
    
        if (parseInt(nowIndex) + 1 == itemArr.length) {
          nowIndex = 0;
        } else {
          nowIndex++;
        }
        $(".outLine_box").eq(nowIndex).show().siblings().hide();
          $(".titleItem")
            .eq(nowIndex)
            .addClass("active")
            .siblings()
            .removeClass("active");
      }
}


// 新代码

// 获取在途交易
function getOnloadNum(pageno) {
    myFundPageno = pageno;
    if (!isRealName()) {
        $('#onRoadTable').html('<td colspan="5"><div class="hold-box h-min"><p class="no-data">暂无在途交易记录</p></div></td>');
        return;
    }
    var params = { pageno: 1, financedType: 'ZT' };
    toApi_toAcCg('S15Q111', params, function (data) {
        if (!isNull(data.counts) && Number(data.counts) > 0) {
            $('#transitTransaction').removeClass('none')
            $("#number").text(data.counts);

            data.transOrderList.forEach(function (e) {
                e.tranam = toThousands(e.tranam, 2);
            });
            var htmlList = template('onRoad', {
                "list": data.transOrderList
            });
            $('#onRoadTable').html(htmlList);
        } else {
            $('#onRoadTable').html('<td colspan="5"><div class="hold-box h-min"><p class="no-data">暂无在途交易记录</p></div></td>');
        }
    })
}

// 获取总金额\昨、今日收益\累计收益\冻结(在途)总金额
function getOnloadMoney() {
    toApi_toAcCg('S15Q426', { qryType: '1' }, function (res) {
        if (!isNull(res)) {
            var totalAmount = res.totalAmount || 0; //理财资产
            var profitAmountTotal = res.profitAmountTotal || 0; //理财收益
            var dayProfitAmount = res.dayProfitAmount || 0; //理财昨\今日收益
            console.log(new Date().toLocaleDateString().replace('/', '').replace('/', ''));
            var profitDateText = new Date().toLocaleDateString().replace('/', '').replace('/', '') === res.profitCalculateDate ? '今日收益（元）' : '昨日收益（元）';

            $("#market-value").text(toThousands(totalAmount));
            smallFontSize(toThousands(profitAmountTotal), 20, "market-value", "22px");
            setNumberFormatter('allIncome', profitAmountTotal, 2);
            setNumberFormatter('resIncome', dayProfitAmount, 2);
            $('#fundDayIncomeTitle').text(profitDateText);

            $("#amount").text(toThousands(res.frozenAmount));
        }
    })
}

// 获取每个类型对应的资产
function getAssets() {
    var params = {
        // agencyNo: 'ALL',
        channelCode: null
    };
    toApi_toAcCg('S15Q427', params, function (res) {
        // 钱包
        var rateAndColor1 = numberFormatter(res.wallet.profitAmountTotal, 2);
        var rateAndColor21 = numberFormatter(res.dayProfitAmount, 2);
        res.wallet.formatProfitAmountTotal = rateAndColor1.value;
        res.wallet.formatProfitAmountTotalColor = rateAndColor1.color;
        res.wallet.formatDayProfitAmount = rateAndColor21.value;
        res.wallet.formatDayProfitAmountColor = rateAndColor21.color;
        res.wallet.formatAvailableAmount = toThousands(res.wallet.availableAmount);

        var htmlList = template("tpl_row", {
            list: [res.wallet],
        });
        $("#walletList tbody").append(htmlList);

        // 养老基金
        var ylFundList = []; // 直销
        var agencyYlFundList = []; // 代销
        res.ylFundList.forEach(function (item) {
            if (item.detailList && item.detailList.length > 0) {
                item.detailList.forEach(function (detail) {
                    if (detail.isAplusAsset == '1') {
                        if (detail.mainFlag == '1' && Number(detail.availableAmount) > 0) {
                            ylFundList.push(detail)
                        } else if (detail.mainFlag == '0') {
                            ylFundList.push(detail)
                        }
                    } else {
                        agencyYlFundList.push(detail);
                    }
                })
            } else {
                ylFundList.push(item);
            }
        })
        ylFundList.forEach(function (fund) {
            fund.formatAvailableAmount = toThousands(fund.availableAmount);
            var dayIncome;
            if (fund.dayIncomeMap && Object.keys(fund.dayIncomeMap).length > 0) {
                dayIncome = fund.dayIncomeMap[fund.profitCalculateDate] || 0.00;
            }
            fund.formatDayProfitAmount = numberFormatter(dayIncome).value;
            fund.formatDayProfitAmountColor = numberFormatter(dayIncome).color;
            var income = fund.fundType == '04' ? fund.profitAmountTotal : fund.holdProfitAmount;
            fund.formatIncome = numberFormatter(income).value;
            fund.formatIncomeColor = numberFormatter(income).color;
            fund.profitDateText = new Date().toLocaleDateString().replace('/', '').replace('/', '') === fund.profitCalculateDate ? '今日' : '昨日';
        })
        if (ylFundList.length > 0) {
            var htmlList = template('ylProduct', {
                "list": ylFundList
            });
            $('#ylProductTable').html(htmlList);
        } else {
            // $('#productTable').html('<td colspan="5"><div class="hold-box h-min"><p class="no-data">暂无数据</p></div></td>');
            $('#ylFundTitle').addClass("none");
            $('#ylFundTable').addClass("none");
        }

        // 养老代销
        agencyYlFundList.forEach(function (fund) {
            fund.formatAvailableAmount = toThousands(fund.availableAmount);
            var dayIncome;
            if (fund.dayIncomeMap && Object.keys(fund.dayIncomeMap).length > 0) {
                dayIncome = fund.dayIncomeMap[fund.profitCalculateDate] || 0.00;
            }
            fund.formatDayProfitAmount = numberFormatter(dayIncome).value;
            fund.formatDayProfitAmountColor = numberFormatter(dayIncome).color;
            var income = fund.fundType == '04' ? fund.profitAmountTotal : fund.holdProfitAmount;
            fund.formatIncome = numberFormatter(income).value;
            fund.formatIncomeColor = numberFormatter(income).color;
            fund.profitDateText = new Date().toLocaleDateString().replace('/', '').replace('/', '') === fund.profitCalculateDate ? '今日' : '昨日';
        })
        if (agencyYlFundList.length > 0) {
            var htmlList = template('agencyYlProduct', {
                "list": agencyYlFundList
            });
            $('#agencyYlProductTable').html(htmlList);
        } else {
            // $('#productTable').html('<td colspan="5"><div class="hold-box h-min"><p class="no-data">暂无数据</p></div></td>');
            $('#agencyYlFundTitle').addClass("none");
            $('#agencyYlFundTable').addClass("none");
        }


        // 基金
        var fundList = []; // 直销
        var agencyFundList = []; // 代销
        res.fundList.forEach(function (item) {
            if (item.detailList && item.detailList.length > 0) {
                item.detailList.forEach(function (detail) {
                    if (detail.isAplusAsset == '1') {
                        if (detail.mainFlag == '1' && Number(detail.availableAmount) > 0) {
                            fundList.push(detail)
                        } else if (detail.mainFlag == '0') {
                            fundList.push(detail)
                        }
                    } else {
                        agencyFundList.push(detail);
                    }
                })
            } else {
                fundList.push(item);
            }
        })
        fundList.forEach(function (fund) {
            fund.formatAvailableAmount = toThousands(fund.availableAmount);
            var dayIncome;
            if (fund.dayIncomeMap && Object.keys(fund.dayIncomeMap).length > 0) {
                dayIncome = fund.dayIncomeMap[fund.profitCalculateDate] || 0.00;
            }
            fund.formatDayProfitAmount = numberFormatter(dayIncome).value;
            fund.formatDayProfitAmountColor = numberFormatter(dayIncome).color;
            var income = fund.fundType == '04' ? fund.profitAmountTotal : fund.holdProfitAmount;
            fund.formatIncome = numberFormatter(income).value;
            fund.formatIncomeColor = numberFormatter(income).color;
            fund.profitDateText = new Date().toLocaleDateString().replace('/', '').replace('/', '') === fund.profitCalculateDate ? '今日' : '昨日';

            fund.productName = fund.productName ? fund.productName : fund.fundName;
            if (fund.portfolioType && fund.portfolioType == "TP") {
                fund.productCode = "目标盈";
            } else if (fund.portfolioType && fund.portfolioType == "TY") {
                fund.productCode = "止盈";
            } else if (fund.portfolioType && fund.portfolioType == "IP") {
                fund.productCode = "智能定投";
            } else {
                fund.productCode = fund.productCode ? fund.productCode : fund.fundCode;
            }
        })
        if (fundList.length > 0) {
            var htmlList = template('product', {
                "list": fundList
            });
            $('#productTable').html(htmlList);
        } else {
            // $('#productTable').html('<td colspan="5"><div class="hold-box h-min"><p class="no-data">暂无数据</p></div></td>');
            $('#fundTitle').addClass("none");
            $('#fundTable').addClass("none");
        }

        // 代销
        agencyFundList.forEach(function (fund) {
            fund.formatAvailableAmount = toThousands(fund.availableAmount);
            var dayIncome;
            if (fund.dayIncomeMap && Object.keys(fund.dayIncomeMap).length > 0) {
                dayIncome = fund.dayIncomeMap[fund.profitCalculateDate] || 0.00;
            }
            fund.formatDayProfitAmount = numberFormatter(dayIncome).value;
            fund.formatDayProfitAmountColor = numberFormatter(dayIncome).color;
            var income = fund.fundType == '04' ? fund.profitAmountTotal : fund.holdProfitAmount;
            fund.formatIncome = numberFormatter(income).value;
            fund.formatIncomeColor = numberFormatter(income).color;
            fund.profitDateText = new Date().toLocaleDateString().replace('/', '').replace('/', '') === fund.profitCalculateDate ? '今日' : '昨日';
        })
        if (agencyFundList.length > 0) {
            var htmlList = template('agencyProduct', {
                "list": agencyFundList
            });
            $('#agencyProductTable').html(htmlList);
        } else {
            // $('#productTable').html('<td colspan="5"><div class="hold-box h-min"><p class="no-data">暂无数据</p></div></td>');
            $('#agencyFundTitle').addClass("none");
            $('#agencyFundTable').addClass("none");
        }

        // 投顾资产
        var stgFundList = res.stgFundList;
        stgFundList.forEach(function (item) {
            item.formatAvailableAmount = toThousands(item.availableAmount);
            var dayTGIncome;
            if (item.dayIncomeMap && Object.keys(item.dayIncomeMap).length > 0) {
                dayTGIncome = item.dayIncomeMap[item.profitCalculateDate] || 0.00;
            }
            item.formatDayProfitAmount = numberFormatter(dayTGIncome).value;
            item.formatDayProfitAmountColor = numberFormatter(dayTGIncome).color;
            item.formatProfitAmountTotal = numberFormatter(item.profitAmountTotal).value;
            item.formatProfitAmountTotalColor = numberFormatter(item.profitAmountTotal).color;
        })
        if (stgFundList.length > 0) {
            var htmlList = template('tgProduct', {
                "list": stgFundList
            });
            $('#tgproductTable').html(htmlList);
        } else {
            $('#tougu').addClass("none");
            // $('#tgproductTable').html('<td colspan="5"><div class="hold-box h-min"><p class="no-data">暂无数据</p></div></td>');
        }

        // 组合资产
        var combFundList = res.combFundList;
        combFundList.forEach(function (item) {
            item.formatAvailableAmount = toThousands(item.availableAmount);
            var dayCombIncome;
            if (item.dayIncomeMap && Object.keys(item.dayIncomeMap).length > 0) {
                dayCombIncome = item.dayIncomeMap[item.profitCalculateDate] || 0.00;
            }
            item.formatDayProfitAmount = numberFormatter(dayCombIncome).value;
            item.formatDayProfitAmountColor = numberFormatter(dayCombIncome).color;
            item.formatProfitAmountTotal = numberFormatter(item.profitAmountTotal).value;
            item.formatProfitAmountTotalColor = numberFormatter(item.profitAmountTotal).color;
        })
        if (combFundList.length > 0) {
            var htmlList = template('combinedTemplate', {
                "list": combFundList
            });
            $('#combinedList').html(htmlList);
        } else {
            // $('#combinedList').html('<td colspan="5"><div class="hold-box h-min"><p class="no-data">暂无数据</p></div></td>');
            $('#comb').addClass("none")
        }

        // 专户资产
        var spFundList = []; // 直销
        var agencySpFundList = []; // 代销
        res.spFundList.forEach(function (item) {
            if (item.detailList && item.detailList.length > 0) {
                item.detailList.forEach(function (detail) {
                    if (detail.isAplusAsset == '1') {
                        if (detail.mainFlag == '1' && Number(detail.availableAmount) > 0) {
                            spFundList.push(detail)
                        } else if (detail.mainFlag == '0') {
                            spFundList.push(detail)
                        }
                    } else {
                        agencySpFundList.push(detail);
                    }
                })
            } else {
                spFundList.push(item);
            }
        })
        // 直销专户
        spFundList.forEach(function (sp) {
            sp.formatAvailableAmount = toThousands(sp.availableAmount);
            var daySPIncome;
            if (sp.dayIncomeMap && Object.keys(sp.dayIncomeMap).length > 0) {
                daySPIncome = sp.dayIncomeMap[sp.profitCalculateDate] || 0.00;
            }
            sp.formatDayProfitAmount = numberFormatter(daySPIncome).value;
            sp.formatDayProfitAmountColor = numberFormatter(daySPIncome).color;
            sp.formatProfitAmountTotal = numberFormatter(sp.holdProfitAmount).value;
            sp.formatProfitAmountTotalColor = numberFormatter(sp.holdProfitAmount).color;
            sp.profitDateText = new Date().toLocaleDateString().replace('/', '').replace('/', '') === sp.profitCalculateDate ? '今日' : '昨日';
            toApi_toAcCg('S15Q087', { fundCode: sp.fundCode }, function (spData) {
                sp.buyFlag = spData.isBuy;
                sp.risklevel = spData.fundRiskLevelCode;
            })
        })
        console.log(spFundList);
        setTimeout(function () {
            if (spFundList.length > 0) {
                var htmlList = template('pro', {
                    "list": spFundList
                });
                $('#proTable').html(htmlList);
            } else {
                $('#gdDiv').addClass("none");
                $('#gdTable').addClass("none");
            }
        }, 300)

        // 代销专户
        agencySpFundList.forEach(function (sp) {
            sp.formatAvailableAmount = toThousands(sp.availableAmount);
            var daySPIncome;
            if (sp.dayIncomeMap && Object.keys(sp.dayIncomeMap).length > 0) {
                daySPIncome = sp.dayIncomeMap[sp.profitCalculateDate] || 0.00;
            }
            sp.formatDayProfitAmount = numberFormatter(daySPIncome).value;
            sp.formatDayProfitAmountColor = numberFormatter(daySPIncome).color;
            sp.formatProfitAmountTotal = numberFormatter(sp.holdProfitAmount).value;
            sp.formatProfitAmountTotalColor = numberFormatter(sp.holdProfitAmount).color;
            sp.profitDateText = new Date().toLocaleDateString().replace('/', '').replace('/', '') === sp.profitCalculateDate ? '今日' : '昨日';
            toApi_toAcCg('S15Q087', { fundCode: sp.fundCode }, function (spData) {
                sp.buyFlag = spData.isBuy;
                sp.risklevel = spData.fundRiskLevelCode;
            })
        })
        console.log(agencySpFundList);
        setTimeout(function () {
            if (agencySpFundList.length > 0) {
                var htmlList = template('agencyPro', {
                    "list": agencySpFundList
                });
                $('#agencyProTable').html(htmlList);
            } else {
                $('#agencyGdDiv').addClass("none");
                $('#agencyGdTable').addClass("none");
            }
        }, 300)
    })
}

// 点击卖出按钮
function gotoSale(fundCode) {
    toApi_toAcCg('S15Q032', { fundCode: fundCode }, function (data) {
        sale(fundCode, data.shareType, data.fundState, data.fundSubType, data.openDateStart, data.openDateEnd, data.nowTime, data.isPortfolioAsset)
    })
}

// 点击转换按钮
function gotoTransfer(fundCode, availableShare) {
    toApi_toAcCg('S15Q032', { fundCode: fundCode }, function (value) {
        var beforeAvailableShare;
        var afterAvailableShare;
        value.shareType == '0' ? beforeAvailableShare = availableShare : afterAvailableShare = availableShare;

        fundTransfer(value.limitExflag, value.fundState, value.fundName, value.fundCode, beforeAvailableShare, afterAvailableShare, value.shareType, availableShare, 1, value.isPortfolioAsset)
    })
}

// 点击买入按钮
function gotoBuy(fundCode) {
    toApi_toAcCg('S15Q032', { fundCode: fundCode }, function (value) {
        fundBuy(fundCode, value.onShelf, value.fundState, '0')
    })
}